import { render, staticRenderFns } from "./TutorBreakCardMealBreakRequest.vue?vue&type=template&id=58280244&"
import script from "./TutorBreakCardMealBreakRequest.vue?vue&type=script&lang=js&"
export * from "./TutorBreakCardMealBreakRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports